module.exports = __webpack_public_path__ + "static/media/art-colors-culture.9ea8e75e.png";